const getDefault = () => {
  return {
    id: null,
    recipientsData: null,
    addressValidation: {},
    numberOfRecipients: 0,
    addressType: 'FILE',
    targetType: 'FILE',
    senderInformation: {},
    selectedAddressOption: null,
    fileName: null
  }
}

export default {
  namespaced: true,
  state: Object.assign({}, getDefault()),
  mutations: {
    SAVE(state, data) {
      state.id = data.id
      state.recipientsData = data.zoneCount
      state.numberOfRecipients = data.total
      state.fileName = data.fileName
      state.addressValidation = data.addressValidation
    },
    SAVE_SENDER(state, data) {
      if (!data) {
        return
      }

      state.senderInformation = data
    },
    SAVE_OPTION(state, data) {
      state.selectedAddressOption = data
    },
    RESET_STATE(state) {
      state.id = null
      state.recipientsData = null
      state.numberOfRecipients = 0
      state.addressType = 'FILE'
      state.targetType = 'FILE'
      state.fileName = ''
      state.addressValidation = {}
    },
    RESET_STATE_ALL(state) {
      const defaultVal = getDefault()

      if (state.senderInformation.saveInformation) {
        defaultVal.senderInformation = state.senderInformation
      }

      state = Object.assign(state, defaultVal)
    }
  }
}
